import { useEffect, useState } from "react";

import classnames from "classnames";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import { Collapse } from "neetoicons";
import { Button } from "neetoui";
import PropTypes from "prop-types";

import Block from "./Block";
import { SIZES } from "./constants";
import DetailsBlock from "./DetailsBlock";
import "./metadata.scss";

const Metadata = ({
  headerBlock,
  size = SIZES.medium,
  children,
  className = "",
}) => {
  const { isSize } = useBreakpoints();
  const isLargerScreen = isSize("desktop") || isSize("largeDesktop");
  const [isElementsPanelCollapsed, setIsElementsPanelCollapsed] =
    useState(!isLargerScreen);

  useEffect(() => {
    setIsElementsPanelCollapsed(!isLargerScreen);
  }, [isLargerScreen]);

  return (
    <>
      {!isElementsPanelCollapsed && (
        <div
          className="neeto-molecules-metadata-panel__backdrop"
          onClick={() => {
            setIsElementsPanelCollapsed(!isElementsPanelCollapsed);
          }}
        />
      )}
      <div
        className={classnames("neeto-molecules-metadata-list-panel__wrapper", {
          "neeto-molecules-metadata-list-panel__wrapper--collapsed":
            isElementsPanelCollapsed,
        })}
      >
        <div className="neeto-molecules-metadata-list-panel__container">
          <div
            data-testid="neeto-molecules-metadata-wrapper"
            className={classnames(
              "neeto-ui-bg-white neeto-molecules-metadata neeto-ui-border-gray-200 h-dvh flex-shrink-0 overflow-y-auto overflow-x-hidden border-l rtl:border-l-0 rtl:border-r",
              {
                "neeto-molecules-metadata--size-large": size === SIZES.medium,
                "neeto-molecules-metadata--size-small": size === SIZES.small,
              },
              className
            )}
          >
            {headerBlock && (
              <div
                className="neeto-molecules-metadata__header mb-5 flex w-full justify-center"
                data-testid="neeto-molecules-metadata-header"
              >
                {headerBlock}
              </div>
            )}
            {children}
          </div>
        </div>
        <Button
          className="neeto-molecules-metadata-list-panel__toggler"
          icon={Collapse}
          style="secondary"
          onClick={() => {
            setIsElementsPanelCollapsed(!isElementsPanelCollapsed);
          }}
        />
      </div>
    </>
  );
};

Metadata.Block = Block;
Metadata.DetailsBlock = DetailsBlock;

Metadata.propTypes = {
  /**
   * To specify the content to be rendered as the title of the `Metadata` wrapper.
   */
  headerBlock: PropTypes.node,
  /**
   * The content to be rendered inside the `Metadata` wrapper.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * To specify external classNames as overrides to the `Metadata` component.
   */
  className: PropTypes.string,
  /**
   * To set the size of the `Metadata` wrapper.
   */
  size: PropTypes.oneOf(["small", "medium"]),
};

export default Metadata;
